import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { H3 } from "./H3Block";
import { defaultData } from "./H3BlockDefaultData";
import { meta } from "./H3BlockMetaData";

export const H3Block: BlockExport = {
  type: "component",
  Block: H3,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-heading",
    size: 24,
  },
  defaultData,
  meta,
};
